import React from "react";

const RibbonSection = () => {
return ( <section className="ribbon-section">

  <div className="ribbon ribbon1">
    <div className="ribbon-track">
      Innovation in action, excellence in execution.
      &nbsp;&nbsp;&nbsp;
      Innovation in action, excellence in execution.
      &nbsp;&nbsp;&nbsp;
      Innovation in action, excellence in execution.
    </div>
  </div>

  <div className="ribbon ribbon2">
    <div className="ribbon-track">
      Innovation in action, excellence in execution.
      &nbsp;&nbsp;&nbsp;
      Innovation in action, excellence in execution.
      &nbsp;&nbsp;&nbsp;
      Innovation in action, excellence in execution.
    </div>
  </div>

</section>


);
};

export default RibbonSection;
